import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { getTabsList } from "../data/services/API";

const TabsContext = createContext();

export const useTabsList = () => {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error("useTabsList must be used within a TabsProvider");
  }
  return context;
};

export const TabsProvider = ({ children }) => {
  const [tabsList, setTabsList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Memoize fetchTabsList to prevent unnecessary re-renders in child components that depend on this function
  const fetchTabsList = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const resp = await getTabsList();
      setTabsList(resp.data);
    } catch (error) {
      setError(error);
      setTabsList(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearTabsList = useCallback(() => {
    setTabsList(null);
    setError(null);
  }, []);

  const value = useMemo(
    () => ({
      tabsList,
      isLoading,
      error,
      fetchTabsList,
      clearTabsList,
    }),
    [tabsList, isLoading, error, fetchTabsList, clearTabsList]
  );

  return <TabsContext.Provider value={value}>{children}</TabsContext.Provider>;
};
